import axios from "axios";

export const apiRequest = async ({
  url,
  method = "GET",
  data = {},
  headers = {},
  withAuth = false,
}) => {
  try {
    const config = {
      method,
      url: `${process.env.REACT_APP_MAIN_SITE_URL}${url}`,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    };

    if (withAuth) {
      const token = localStorage.getItem("token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    if (method.toUpperCase() === "GET") {
      config.params = data;
    } else {
      config.data = data;
    }

    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("API Request Error:", error);
    throw error.response?.data || { message: "Unknown error" };
  }
};
